import { ChartInterval } from './chart-interval.model';

export class ChartIntervals {
	static List: Array<ChartInterval> = [
		<ChartInterval>{ minutes: 5, label: '5 min' },
		<ChartInterval>{ minutes: 10, label: '10 min' },
		<ChartInterval>{ minutes: 15, label: '15 min' },
		<ChartInterval>{ minutes: 30, label: '30 min' },
		<ChartInterval>{ minutes: 60, label: '1 hr' },
		<ChartInterval>{ minutes: 120, label: '2 hr' },
		<ChartInterval>{ minutes: 240, label: '4 hrs' },
		<ChartInterval>{ minutes: 480, label: '8 hrs' },
		<ChartInterval>{ minutes: 720, label: '12 hrs' },
		<ChartInterval>{ minutes: 1440, label: '24 hrs' },
		<ChartInterval>{ minutes: 0, label: 'All' },
		<ChartInterval>{ minutes: null, label: '---' }
	];
}
